import React, {useEffect} from "react";
import {Image} from "semantic-ui-react";
import membershipCard from "../assets/images/membership-card.png";
import membershipCard2 from "../assets/images/membership-card-2.png";
import membershipCardMobile from "../assets/images/membership-card-mobile.png";
import membershipCardWeb from "../assets/images/membership-card-web.png";
import {ReactSVG} from "react-svg";
import DownloadIcon from "../assets/images/download-icon.svg";
import {useNavigationHandler} from "../contexts/Navigation";
import {handleSaveAndExit} from "../helpers/common";
import {gaJSON, useTrackFirebaseAnalytics} from "../utils/googleAnalytics";

const DownloadMembershipCard = () => {
    const {
        handleFooterNextButtonText,
        registerCallbackFunction,
        handleContinueButtonLoading
    } = useNavigationHandler();

    const track = useTrackFirebaseAnalytics();

    useEffect(() => {
        handleFooterNextButtonText("Finalize Onboarding");
        registerCallbackFunction(() => async () => {
            handleContinueButtonLoading(true)
            await track(gaJSON.onboarding_completed, {
                time: new Date()
            })
            handleSaveAndExit()
        });
        track(gaJSON.onboarding_screen_viewed, {step_name: "download-membership-card"})
    }, [])

    return <div className="download-membership">
        <div>
            <p className="step">STEP 2 of 2</p>
            <p className="step-title">Download Membership Card</p>
        </div>
        <p className="description">Membership cards streamline the experience for drivers at repair shops. We recommend
            keeping it in the glovebox so it’s always on hand when needed. </p>
        <p className="text-bold-md">Three way to access the membership card:</p>
        <div className="steps-container">
            <div className="card-outline">
                <div className="card-title-container">
                    <div className="notification-badge">
                        1
                    </div>
                    <span className="text-bold">Download & Print</span>
                </div>
                <p className="text-secondary-sm">Print and distribute membership cards for all drivers and vehicles.</p>
                <div className="flex-row-between">
                    <Image src={membershipCard2} alt="Download Membership Card" width={95} height={162}
                           style={{border: '1px solid #F2F2F2', borderRadius: '8px'}}/>
                    <Image src={membershipCard} alt="Download Membership Card" width={95} height={162}
                           style={{border: '1px solid #F2F2F2', borderRadius: '8px'}}/>
                </div>
                <button className="download-button"
                        onClick={() => window.open('/SFO_Membership_card.pdf')}>Download <ReactSVG src={DownloadIcon}/>
                </button>
            </div>
            <div className="card-outline">
                <div className="card-title-container">
                    <div className="notification-badge">
                        2
                    </div>
                    <span className="text-bold">Driver Mobile App</span>
                </div>
                <div>
                    <p className="text-secondary-sm">Drivers can access Membership Cards directly from
                        the Fuelman Maintenance app!</p>
                    <p className="text-secondary-sm">Simply show to the shop upon arrival.</p>
                </div>

                <div className="flex-row-spaced">
                    <ol className="ordered-list-step-2">
                        <li>Click on the User icon.</li>
                        <li>Driver selects a vehicle to view the specific membership card.</li>
                        <li>Drivers only have access to membership cards for their assigned vehicles.</li>
                    </ol>
                    <Image src={membershipCardMobile} alt="Download Membership Card" width={94} height={250}
                           style={{flex: '1 1 0px', borderRadius: '8px'}}/>
                </div>
            </div>
            <div className="card-outline">
                <div className="card-title-container">
                    <div className="notification-badge">
                        3
                    </div>
                    <span className="text-bold">Online Account</span>
                </div>
                <p className="text-secondary-sm">Additional membership cards are easily accessible in your online
                    account.</p>
                <ol className="ordered-list-step-3">
                    <li>Click on Membership Card located on the top of each page.</li>
                    <li>Print & distribute to drivers and vehicles, as needed.</li>
                </ol>
                <Image src={membershipCardWeb} alt="Download Membership Card" height={116}/>
            </div>
        </div>
    </div>
}

export default DownloadMembershipCard;
